import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form, Button } from 'semantic-ui-react';
import moment from 'moment';

import { ReportFieldEnum } from 'Common/FieldEnum';
import { SelectField, DatePickerField } from 'Common/SemanticWrapper';
import { SiteComponent } from 'Common/SiteComponent';
import { DropdownObjectCreator } from 'Common/ObjectHelper';
import { TitledCard } from 'Components';
import { CREDIT_CARD_PAYMENT_FORM_NAME } from 'Common/FormEnum';

const groupBy = [
  { value: '1', name: 'Site' },
  { value: '2', name: 'User' },
];
const sortBy = [
  { value: '1', name: 'Student ID' },
  { value: '2', name: 'Time' },
];

class CreditCardPaymentForm extends Component {
  state = {
    [ReportFieldEnum.GroupBy]: null,
    [ReportFieldEnum.SortBy]: null,
  };

  componentDidMount() {
    const { initialValues } = this.props;
    this.setState({
      [ReportFieldEnum.GroupBy]: initialValues[ReportFieldEnum.GroupBy],
      [ReportFieldEnum.SortBy]: initialValues[ReportFieldEnum.SortBy],
    });
  }

  changeSites = data => {
    this.props.change(`${ReportFieldEnum.User}`, 'ALL');
  };

  buttonChange = (e, value, field) => {
    const { change } = this.props;
    e.preventDefault();
    this.setState({ [field]: value });
    change(field, value);
  };

  buttonGroup = (buttonList, field) => {
    return (
      <Grid.Column>
        <Button.Group basic className="btn-group--active-group">
          {buttonList.map(button => (
            <Button
              key={button.name}
              basic
              className="white"
              active={this.state[field] === button.value}
              onClick={e => this.buttonChange(e, button.value, [field])}
            >
              {button.name}
            </Button>
          ))}
        </Button.Group>
      </Grid.Column>
    );
  };

  render() {
    const { usersData } = this.props;
    let users = [];
    users = usersData
      ? DropdownObjectCreator(usersData, 'UserId', 'UserName')
      : [];
    if (users.length > 1) {
      users.unshift({
        value: 'ALL',
        text: 'ALL',
        key: 'valueALL',
      });
    }

    return (
      <Form>
        <TitledCard title={'Report Parameters'}>
          <Grid columns={1} style={{ paddingBottom: '10px' }}>
            <Grid.Row>
              <Grid.Column width={8}>
                <SiteComponent
                  name={ReportFieldEnum.Site}
                  onChange={this.changeSites}
                  {...this.props}
                  isForm={true}
                  isPrimary={true}
                />
              </Grid.Column>
              <Grid.Column width={6}>
                <Field
                  name={ReportFieldEnum.User}
                  component={SelectField}
                  type="text"
                  label="USER"
                  options={users}
                  loading={this.props.userLoad}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <Field
                  name={ReportFieldEnum.FromDate}
                  component={DatePickerField}
                  type="text"
                  label="From"
                  openToDate={moment().add(-1, 'days')}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  name={ReportFieldEnum.ToDate}
                  component={DatePickerField}
                  type="text"
                  label="To"
                  openToDate={moment()}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingBottom: '0px' }}>
              <Grid.Column>
                <div className="field">
                  <label>GROUP BY</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingTop: '0px' }}>
              {this.state[ReportFieldEnum.GroupBy] &&
                this.buttonGroup(groupBy, [ReportFieldEnum.GroupBy])}
            </Grid.Row>
            <Grid.Row style={{ paddingBottom: '0px' }}>
              <Grid.Column>
                <div className="field">
                  <label>SORT BY</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingTop: '0px' }}>
              {this.state[ReportFieldEnum.SortBy] &&
                this.buttonGroup(sortBy, [ReportFieldEnum.SortBy])}
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  if (!moment(values[ReportFieldEnum.FromDate]).isValid()) {
    errors[ReportFieldEnum.FromDate] = 'Enter a valid From Date.';
  }
  if (!values[ReportFieldEnum.FromDate]) {
    errors[ReportFieldEnum.FromDate] = 'From Date must be set.';
  }
  if (
    moment(values[ReportFieldEnum.ToDate]).isBefore(
      moment(values[ReportFieldEnum.FromDate])
    )
  ) {
    errors[ReportFieldEnum.ToDate] = 'To Date must be after From Date.';
  }
  if (!moment(values[ReportFieldEnum.ToDate]).isValid()) {
    errors[ReportFieldEnum.ToDate] = 'Enter a valid To Date.';
  }
  if (!values[ReportFieldEnum.ToDate]) {
    errors[ReportFieldEnum.ToDate] = 'To Date must be set.';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: CREDIT_CARD_PAYMENT_FORM_NAME,
  destroyOnUnmount: false,
})(CreditCardPaymentForm);



// WEBPACK FOOTER //
// ./src/pages/creditcardpayment/components/CreditCardPaymentForm.js